import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { TypeCodeState } from '../../types';

type TypeSkipFeaturesStore = {
  /** 사내망 IP 체크 여부
   * @summary 편의를 위해 제공하는 상태값으로 [근로계약 등록 / 근로계약 양식 조회 / 근로계약 서명] API 요청 시 사내망 IP 체크를 스킵 가능
   * @remarks true인 경우, 요청 헤더에 { Restrict-Access-Api: PASS } 추가
   */
  isSkipIpCheck: boolean;
  /** 클러스터 변조 정보
   * @description 편의를 위해 제공하는 상태값으로 클라이언트 IP 확인 API 요청 시, 클러스터 정보 변조 가능
   * @remarks null이 아닌 경우, 요청 헤더에 { Want-Cluster-Response: cluster.code } 추가
   */
  changedNetworkIp: TypeCodeState | null;
  actions: {
    setIsSkipIpCheck: (isSkipIpCheck: boolean) => void;
    setChangedNetworkIp: (changedNetworkIp: TypeCodeState | null) => void;
  };
};

/** @description 특정 기능 스킵 여부와 상태값 변경 정보를 가지고 있는 상태 */
export const useSkipFeaturesStore = create<TypeSkipFeaturesStore>()(
  devtools((set) => ({
    isSkipIpCheck: false,
    changedNetworkIp: null,
    actions: {
      setIsSkipIpCheck: (isSkipIpCheck) => set({ isSkipIpCheck }),
      setChangedNetworkIp: (changedNetworkIp) => set({ changedNetworkIp }),
    },
  }))
);
